"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var SqlParser_1 = require("../../Parsers/SQL/SqlParser");
var TextUtils_1 = require("../../Utils/TextUtils");
var XoneTestResulset = /** @class */ (function () {
    /**
     *
     */
    function XoneTestResulset(strCmd) {
        this.m_stringData = ['Valor prueba texto', 'Texto corto', '0002346', 'Otro texto', 'Un texto mas largo de prueba', 'Mas texto'];
        this.m_maxRows = 100;
        this.isResultset = true;
        this.m_nIterate = 0;
        this.m_parsed = new SqlParser_1.SqlParser("ROWID");
        this.m_parsed.ParseSqlString(strCmd);
    }
    XoneTestResulset.prototype.getBytes = function (fld) {
        return null;
    };
    XoneTestResulset.prototype.getColumnCount = function () {
        return this.m_parsed.getQueryFields().length;
    };
    XoneTestResulset.prototype.getColumnTypes = function () {
        return [1, 2, 3, 4, 5, 6, 7, 8];
    };
    XoneTestResulset.prototype.getColumnName = function (ordinal) {
        if (ordinal < this.m_parsed.getQueryFields().length) {
            var name_1 = this.m_parsed.getQueryFields()[ordinal].getResolvedName();
            if (name_1.endsWith('*') || TextUtils_1.default.isEmpty(name_1))
                name_1 = "Column" + ordinal;
            return name_1;
        }
        return "Column" + ordinal;
    };
    XoneTestResulset.prototype.getData = function () {
        return this.m_stringData;
    };
    XoneTestResulset.prototype.close = function () {
        this.m_nIterate = 0;
    };
    XoneTestResulset.prototype.getValue = function (fld, nType) {
        switch (nType) {
            case 0: // Numero
                return Math.floor(Math.random() * (1000 - 1)) + 1;
            case 2:
                return Math.random() * (1000 - 1) + 1;
            case 3:
                return new Date();
            default:
                return this.m_stringData[Math.floor(Math.random() * 6)];
        }
        return "Test Value";
    };
    XoneTestResulset.prototype.getString = function (fld) {
        return "test string";
    };
    XoneTestResulset.prototype.getInt = function (fld) {
        return Math.floor(Math.random() * (1000 - 1)) + 1;
    };
    XoneTestResulset.prototype.getDate = function (fld) {
        return new Date();
    };
    XoneTestResulset.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.m_nIterate++ != this.m_maxRows];
            });
        });
    };
    XoneTestResulset.prototype.EOF = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.m_nIterate == this.m_maxRows];
            });
        });
    };
    XoneTestResulset.prototype.moveTo = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, position == this.m_maxRows || (this.m_nIterate = position) == this.m_maxRows];
            });
        });
    };
    return XoneTestResulset;
}());
exports.default = XoneTestResulset;

//# sourceMappingURL=XoneTestResulset.js.map
